import React from 'react'
import styled, { css } from 'styled-components'
import { Size, Text } from 'lib/Text'

const Stars = styled.div`
  align-items: center;
  display: flex;
  flex: 0 1 110px;
  column-gap: 5px;
  padding: 8px 0;

  ${Text} {
    margin: 0 8px;
  }
`
const Star = styled.span<{ filled: boolean; starSize: string }>`
  border-radius: 50%;
  background-color: var(--black-20);
  display: inline-block;
  height: ${(props) => props.starSize};
  width: ${(props) => props.starSize};
  transition: background-color 0.25s;
  position: relative;
  overflow: hidden;

  ${(props) =>
    props.filled &&
    css`
      background-color: var(--black-100);
    `}
`

const PartialStar = styled.span`
  background-color: var(--black-100);
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
`

interface Props {
  className?: string
  stars: number
  showCount?: boolean
  starSize?: Size
}

export const StarRating = ({ stars, className, showCount = false, starSize = 'ps' }: Props) => (
  <Stars className={className}>
    {[1, 2, 3, 4, 5].map((currentStar) => {
      const filled = stars >= currentStar
      const fraction = 1 - (currentStar % stars)

      // Show the fraction on the current star if there is a fraction to show and we're on the
      // 'correct' current star. For example, if the review score is 2.3, then the star which will
      // show the fraction is the 3rd star. Math.ceil(2.3) = 3
      const shouldShowFraction = Math.ceil(stars) === currentStar && fraction < 1
      const maybePercent = shouldShowFraction ? fraction * 100 : undefined
      return (
        <Star key={currentStar} filled={filled} starSize={`var(--text-size-${starSize})`}>
          {maybePercent && <PartialStar style={{ width: `${maybePercent}%` }} />}
        </Star>
      )
    })}
    {showCount && (
      <Text as="span" size="ps" weight="medium" color="black-40">
        {stars}/5
      </Text>
    )}
  </Stars>
)
